module.exports = __webpack_public_path__ + "img/gallery-image-26.140868b2.jpg";